import { render, staticRenderFns } from "./EarthquakePrediction.vue?vue&type=template&id=c9e39928&scoped=true&"
import script from "./EarthquakePrediction.vue?vue&type=script&lang=js&"
export * from "./EarthquakePrediction.vue?vue&type=script&lang=js&"
import style0 from "./EarthquakePrediction.vue?vue&type=style&index=0&id=c9e39928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e39928",
  null
  
)

export default component.exports